import useMobilizeStore, { mobilizeInitialState } from '.'

export const resetMobilizeStore = () => {
  useMobilizeStore.setState({ ...mobilizeInitialState })
}
